import { useContext } from 'react';
import EventCollectorContext from './EventCollectorContext';

export default function useEventCollector() {
  return useContext(EventCollectorContext);
}
